import React, {lazy, Suspense} from 'react'

const Team = lazy(() => import('../Components/Team/Team'));

const ServicePage = () => {
    return (
     <>
     <Suspense fallback={<div></div>}><Team/></Suspense> 
      </>
    );
  }
  
  export default ServicePage ;